"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="4805" id="call-to-action" className="relative overflow-hidden bg-background py-32 px-6 text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
        <span className="font-default font-bold leading-none text-primary/[0.05]" style={{
        fontSize: "25vw"
      }}>
          CHIP
        </span>
      </div>

      {}
      <div ref={ref} className={`relative mx-auto max-w-[900px] text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <Separator />

        {}
        <p className="mt-12 font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-secondary">
          Ready to Transform Your Land?
        </p>

        {}
        <h2 className="font-default font-bold text-foreground mt-10 leading-[1.05]" style={{
        fontSize: "clamp(3rem, 7vw, 6rem)"
      }}>
          <span className="block">Clear the way for</span>
          <span className="block text-primary">new growth.</span>
        </h2>

        {}
        <p className="mt-10 font-default text-xl sm:text-[1.25rem] leading-relaxed text-muted-foreground">
          Professional forestry mulching and land clearing services tailored to your property.
        </p>

        {}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
          <Button asChild size="lg" className="rounded-lg px-10 py-6 h-auto bg-primary text-primary-foreground hover:bg-primary/90 font-default font-semibold text-base tracking-wide shadow-lg">
            <Link to="/ContactUsPage">Schedule a Site Visit</Link>
          </Button>

          <Link to="/ServicesPage" className="font-default font-medium text-base text-secondary hover:text-primary transition-colors duration-300 underline-offset-4 hover:underline">
            explore our services →
          </Link>
        </div>

        {}
        <div className="mt-16">
          <Separator />
        </div>
      </div>
    </section>;
}
function Separator() {
  return <div className="mx-auto h-px w-full max-w-[600px] bg-border" />;
}